import { useEffect, useState } from "react";
import { Autocomplete, Grid, TextField } from "../../../../components";
import { value } from "../../../../helpers";
import { FamiliaProdutosService, GrupoProdutosService, SubfamiliaProdutosService, SubgrupoProdutosService } from "../../../../services";

const grupoProdutosService = new GrupoProdutosService();
const subgrupoProdutosService = new SubgrupoProdutosService();
const familiaProdutosService = new FamiliaProdutosService();
const subfamiliaProdutosService = new SubfamiliaProdutosService();

const FiltroImpressaoGrupoProduto = ({
  filtroImpressao,
  setFiltroImpressao,
  inputErros
}) => {

  const [listaGruposProdutos, setListaGruposProdutos] = useState([]);
  const [listaSubgruposProdutos, setListaSubgruposProdutos] = useState([]);
  const [listaFamiliasProdutos, setListaFamiliasProdutos] = useState([]);
  const [listaSubfamiliasProdutos, setListaSubfamiliasProdutos] = useState([]);

  useEffect(() => {
    buscarGruposProdutos();
    buscarSubgruposProdutos();
    buscarFamiliasProdutos();
    buscarSubfamiliasProdutos();
  }, []);

  const buscarGruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    grupoProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaGruposProdutos(res.data);
      } else {
        setListaGruposProdutos([]);
      }
    });
  };

  const buscarSubgruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subgrupoProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaSubgruposProdutos(res.data);
      } else {
        setListaSubgruposProdutos([]);
      }
    });
  };

  const buscarFamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    familiaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaFamiliasProdutos(res.data);
      } else {
        setListaFamiliasProdutos([]);
      }
    });
  };

  const buscarSubfamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subfamiliaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaSubfamiliasProdutos(res.data);
      } else {
        setListaSubfamiliasProdutos([]);
      }
    });
  };

  const handleChangeAutocomplete = (value, name) => {
    setFiltroImpressao((prevState) => ({
      ...prevState,
      [name]: value?.id
    }));
  }

  return (
    <>
    <Grid item xs={6}>
      <Autocomplete
        required
        id="grupoProdutoId"
        name="grupoProdutoId"
        options={listaGruposProdutos}
        noOptionsText="Sem opções"
        autoHighlight
        getOptionLabel={(option) =>
          option?.codigo && option?.descricao
            ? `${option.codigo} - ${option.descricao}`
            : ""
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Grupo de Produto"
            margin="none"
            required
            sx={{ mt: 2, mb: 1 }}
            InputProps={{
              ...params.InputProps,
            }}
            error={inputErros.get("grupoProduto")}
          />
        )}
        onChange={(e, value) => handleChangeAutocomplete(value, 'grupoProdutoId')}
        value={value.autoComplete(listaGruposProdutos, filtroImpressao?.grupoProdutoId)}
      />
    </Grid>
    <Grid item xs={6}>
      <Autocomplete
        required
        id="subgrupoProdutoId"
        name="subgrupoProdutoId"
        options={listaSubgruposProdutos}
        noOptionsText="Sem opções"
        autoHighlight
        getOptionLabel={(option) =>
          option?.codigo && option?.descricao
            ? `${option.codigo} - ${option.descricao}`
            : ""
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Subgrupo de Produto"
            margin="none"
            required
            InputProps={{
              ...params.InputProps,
            }}
            sx={{ mt: 2, mb: 1 }}
            error={inputErros.get("grupoProduto")}
          />
        )}
        onChange={(e, value) => handleChangeAutocomplete(value, 'subgrupoProdutoId')}
        value={value.autoComplete(listaSubgruposProdutos, filtroImpressao?.subgrupoProdutoId)}
      />
    </Grid>
    <Grid item xs={6}>
      <Autocomplete
        required
        id="familiaProdutoId"
        name="familiaProdutoId"
        options={listaFamiliasProdutos}
        noOptionsText="Sem opções"
        autoHighlight
        getOptionLabel={(option) =>
          option?.codigo && option?.descricao
            ? `${option.codigo} - ${option.descricao}`
            : ""
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Família de Produto"
            margin="none"
            required
            InputProps={{
              ...params.InputProps,
            }}
            sx={{ mb: 1 }}
            error={inputErros.get("grupoProduto")}
          />
        )}
        onChange={(e, value) => handleChangeAutocomplete(value, 'familiaProdutoId')}
        value={value.autoComplete(listaFamiliasProdutos, filtroImpressao?.familiaProdutoId)}
      />
    </Grid>
    <Grid item xs={6}>
      <Autocomplete
        required
        id="subfamiliaProdutoId"
        name="subfamiliaProdutoId"
        options={listaSubfamiliasProdutos}
        noOptionsText="Sem opções"
        autoHighlight
        getOptionLabel={(option) =>
          option?.codigo && option?.descricao
            ? `${option.codigo} - ${option.descricao}`
            : ""
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Subfamília de Produto"
            margin="none"
            required
            InputProps={{
              ...params.InputProps,
            }}
            sx={{ mb: 1 }}
            error={inputErros.get("grupoProduto")}
          />
        )}
        onChange={(e, value) => handleChangeAutocomplete(value, 'subfamiliaProdutoId')}
        value={value.autoComplete(listaSubfamiliasProdutos, filtroImpressao?.subfamiliaProdutoId)}
      />
    </Grid>
    </>
  );
};

export default FiltroImpressaoGrupoProduto;
